import React from 'react'

const ReviewDetails = ({ tabs, displayTabs, handleTabChange }) => {

  const flattenedTabs = tabs?.flatMap((tab) => {
    const matchedTab = displayTabs?.find(displayTab => displayTab?.tab_id === tab?.tab_id);
    return tab?.questions?.map((question) => {
      const matchedQuestion = matchedTab?.questions?.find(q => q.id === question?.question_id);

      return ({
        tab_name: matchedTab?.tab_name || "Unnamed Tab",
        question_id: question?.question_id,
        question_name: matchedQuestion?.question_name,
        answer: question?.answer || "No answer provided",
        tab_id: matchedTab?.tab_id || 0
      })
    }
    );
  });
  return (
    <div class="form-step active" id="step-6">
      <h2>Review</h2>
      <h3>Review Your Details</h3>
      <div class="review_wrapper">
        <ul class="list">

          {flattenedTabs && flattenedTabs.length > 0 ? (
            flattenedTabs.map((item, index) => (
              <li key={index}>
                <div className="details_sec">
                  <span>{item?.tab_name == "Tax" || item?.tab_name == "Bookkeeping" ? item?.question_name : item.tab_name}</span>
                  <span>{item.answer}</span>
                </div>
                <div className="change_sec">
                  <button onClick={() => handleTabChange(item?.tab_id, item?.question_id)} className="change_btn">Change</button>
                </div>
              </li>
            ))
          ) : (
            <li>No data available</li>
          )}
        </ul>
      </div>
      {/* <button id="step_7_nextBtn" class="nextBtn purchase_btn">Proceed to CheckOut</button> */}
    </div>
  )
}

export default ReviewDetails